import { DateTime } from 'luxon'
import DurationPeriodJson from './interfaces/DurationPeriodJson'

export default class DurationPeriod {
  startDate: DateTime
  endDate: DateTime

  constructor(startDate: DateTime, endDate: DateTime) {
    this.startDate = startDate
    this.endDate = endDate
  }

  isEqual(instance?: DurationPeriod) {
    return (
      instance &&
      instance.startDate.equals(this.startDate) &&
      instance.endDate.equals(this.endDate)
    )
  }

  static fromJson(data: DurationPeriodJson) {
    return new this(
      DateTime.fromISO(data.startDate.date, { zone: data.startDate.timezone }),
      DateTime.fromISO(data.endDate.date, { zone: data.endDate.timezone }),
    )
  }

  toJson(): DurationPeriodJson {
    return {
      startDate: {
        date: this.startDate.toISO() ?? '',
        timezone: this.startDate.zoneName ?? 'UTC',
      },
      endDate: {
        date: this.endDate.toISO() ?? '',
        timezone: this.endDate.zoneName ?? 'UTC',
      },
    }
  }
}
